import axios from "axios";

const instance = axios.create({
    baseURL: 'http://www.zhzscq.com/jeeplus-vue'
})




export default instance
